<main>
    <div class="app app-margin" #container  >
        <section class="nav-area" [dir]="textDir">             
            <div class="row top-section padT15" >
                <div class="md-12 lg-12 xl-12">
                    <section class="breadcrmb labeltxt"><a [routerLink]="['/']" >{{'Home' | translate}}</a> <span class="eds-sep">&nbsp;/&nbsp;</span> <span class="active">{{'Project management' | translate}}</span></section>
                    <div class="marT10 header-title">{{'Project management' | translate}}</div>                   
                </div>
                <div class="row top-section spaceBtwn marT10">
                    <div class="lg-6 sm-12 md-12 count_text padT10" [dir]="textDir">
                        <span>{{projectCount}} {{'Projects' | translate}} &nbsp;</span><span class="Line-Copy-49 separation marR5">|</span>
                        <span>{{schoolCount}} {{'Schools' | translate}} &nbsp;</span><span class="Line-Copy-49 separation marR5">|</span>
                        <span>{{studentCount}} {{'Students' | translate}} &nbsp;</span><span class="Line-Copy-49 separation marR5">|</span>
                        <span>{{teacherCount}} {{'Teachers' | translate}} &nbsp;</span><span class="Line-Copy-49 separation marR5">|</span>
                        <span [ngClass]="textDir=='ltr'?'marR5':''">{{adminCount}} {{'Admins' | translate}} &nbsp;</span>
                    </div>
                <div class="column sm-12 md-12 lg-3 xl-6 add-new-btn flexEnd"> <button type="button" class="btn primary " (click)='addNew()'>{{'Add new' | translate}}</button></div>
		</div>
            </div>            
        </section>
        <div class="app-container-pm" [dir]="textDir">
            <div class="app-container marT20">
                <div class="row" *ngIf="loaded">
                    <div class="column lg-8 md-8 sm-12 proj-filters">
                        <div class="dropDown-width" [ngClass]="textDir=='ltr'? 'marR10':textDir">
                            <ng-container >
                                <ngx-select-dropdown  [(ngModel)]="selectedCountry" [multiple]="false" [options]="countryFilter|unique: 'name' | orderBy: 'name'" [config]="countrySelectConfig" (change)="getfilteredData('countryId',selectedCountry?._id)"></ngx-select-dropdown>
                            </ng-container>
                        </div>
                        
                        <div class="wid-200 marR10" [ngClass]="textDir">
                            <ng-container>
                                <ngx-select-dropdown [(ngModel)]="selectedPartner" [multiple]="false" [options]="partnerFilter| unique: '_id' |orderBy: 'name'" [config]="partnerSelectConfig" (change)="getfilteredData('partnerId',selectedPartner?._id)"></ngx-select-dropdown>
                            </ng-container>
                        </div>
                        
                        <div class="dropDown-width marR10" [ngClass]="textDir">
                            <ng-container >
                                 <ngx-select-dropdown [(ngModel)]="selectedStatus" [multiple]="false" [options]="statusFilter" [config]="statusSelectConfig" (change)="getfilteredData('status',selectedStatus?.state)"></ngx-select-dropdown>
                            </ng-container>
                        </div>
                        <div class="dwn" [ngClass]="textDir=='rtl'?'marR10':''"> <a href="javascript:void(0)" (click)="downloadCsv(this.projectList,'Projects')" class="dwnText">{{'Download dataset'| translate}}</a></div>
                    </div>
                    <div class="column lg-4 md-4 sm-12 flexEnd proj-search">
                       <!--  <div [ngClass]="textDir=='ltr'?'marR20':''">
                            <input type="text" class="with-icon inputwdith font12 search" [(ngModel)]="term" placeholder="{{'Search by name'| translate}}" name="q">
                            <div class="suffix icon-inside"><i class="icon icon-search"></i></div>
                        </div> -->

                        <div [ngClass]="textDir=='rtl'?'marL20':''">
                            <input type="text" class="with-icon inputwdith font12 search" [(ngModel)]="term" placeholder="{{'Search by name'| translate}}" name="q">
                            <div class="suffix icon-inside" [ngClass]="textDir=='rtl'?'marR38':''"><i class="icon icon-search"></i></div>
                        </div>
                        <div class="flexEnd">
                            <div class="grid-icon">
                                <label class="padT5" [ngClass]="{'selected':gridView}">
                                    <input type="Radio" name="radio2text" value="gridView" (click)= 'setGrid()' checked="checked"><i class="icon icon-view-tiles"></i>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="list-icon">
                                <label class="padT5" [ngClass]="{'selected':!gridView}">
                                    <input type="Radio" name="radio2text" value="listView" (click)= 'setList()'><i class="icon icon-view-list"></i>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="loading" *ngIf="!loaded"></div>
                    <div *ngIf="projectList?.length > 0 && loaded" class="column lg-12 md-12 sm-12 xl-12 marT15">
                        <div *ngIf="gridView" class="grid-align">
                            <div class="flexCenter" *ngFor="let item of projectList |  orderBy: 'name' | projectFilter:term | paginate: { itemsPerPage: noOfItems, currentPage: page }; let i = index" (click)=gotoProjectOverview(item) style="cursor: pointer;">
                                <app-ctl-grid-view *ngIf="gridView" dataView="grid"
                                        (toggleDataEvent)="enableDisableProject(item)"
                                        (editDataEvent)="editProjectModal(item)"
                                        (viewDataEvent)="gotoProjectOverview(item)"
                                        [objId]=item?._id
                                        [logo]="fixLogoUrl(item?.logo?.url)"
                                        [title]=item?.name
                                        [description]=item?.description
                                        [extrainfo1]="(item.partners|filterBy: ['type']: 'Lead Partner'|pluck: 'partner')[0]?.name"
                                        [location]=item?.country?.name
                                        [count]="item?.schoolCount || 0"
                                        [dataType]="'Project'"
                                        [status]=item?.active
                                        [(dataIconColor)]=projectIconColor
                                        [loopIndex]=i></app-ctl-grid-view>
                            </div>                            
                        </div>
                        <div *ngIf="!gridView">
                            
                            <table class="table sortable selectable dashed" [dir]="textDir">
                                <thead>
                                  <tr>
                                    <th class="w25" (click)="sortBy('name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'name','desc':this.isSorted && this.propertyName == 'name' && this.orderType,'asc':this.isSorted && this.propertyName == 'name' && !this.orderType}">{{'Project' | translate}}</th>
                                    <th class="w15" (click)="sortBy('country.name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'country.name','desc':this.isSorted && this.propertyName == 'country.name' && this.orderType,'asc':this.isSorted && this.propertyName == 'country.name' && !this.orderType}">{{'Country' | translate}}</th>
                                    <th class="w25" (click)="sortBy('leadPartner')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'leadPartner','desc':this.isSorted && this.propertyName == 'leadPartner' && this.orderType,'asc':this.isSorted && this.propertyName == 'leadPartner' && !this.orderType}">{{'Lead partner' | translate}}</th>
                                    <th class="txtcenter" (click)="sortBy('schoolCount')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'schoolCount','desc':this.isSorted && this.propertyName == 'schoolCount' && this.orderType,'asc':this.isSorted && this.propertyName == 'schoolCount' && !this.orderType}">{{'Schools' | translate}}</th>
                                    <th class ="txtcenter" (click)="sortBy('studentCount')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'studentCount','desc':this.isSorted && this.propertyName == 'studentCount' && this.orderType,'asc':this.isSorted && this.propertyName == 'studentCount' && !this.orderType}">{{'Students' | translate}}</th>
                                    <th (click)="sortBy('active')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'active','desc':this.isSorted && this.propertyName == 'active' && this.orderType,'asc':this.isSorted && this.propertyName == 'active' && !this.orderType}">{{'Status' | translate}}</th>
                                  </tr>
                                </thead>
                                <tbody>                            
                                    <tr *ngFor="let item of projectList| orderBy: propertyNameSorting | projectFilter:term | paginate: { itemsPerPage: noOfItems, currentPage: page }; let i = index" (click)="gotoProjectOverview(item)" style="cursor: pointer;"
                                        app-ctl-list-view
                                        (toggleDataEvent)="enableDisableProject(item)"
                                        (editDataEvent)="editProjectModal(item)"
                                        (viewDataEvent)="gotoProjectOverview(item)"
                                        [objId]="item?._id"
                                        [showlogo]="false"
                                        [logo]="fixLogoUrl(item?.logo?.url)"
                                        [title]="item?.name"
                                        [extrainfo1]="item?.country?.name"
                                        [vextrainfo1]="(item.partners|filterBy: ['type']: 'Lead Partner'|pluck: 'partner')[0]?.name"
                                        [info1]="item?.schoolCount || '0'"
                                        [info2]="item?.studentCount || '0'"
                                        [status]="item?.active"
                                        [(dataIconColor)]="projectIconColor"
                                        [loopIndex]="i">
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>
                                              
                    </div>
                    <div class="lg-12 md-12 sm-12 marT30" *ngIf="projectList?.length > 0 && loaded">
                        <pagination-template #p="paginationApi"  (pageChange)="pageChanged($event)">                                    
                            <lib-ctl-pagination [p]="p"></lib-ctl-pagination>
                        </pagination-template>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</main>

<!------- Success Modal Comp ------>
<lib-ctl-success-modal
  [titleMessage]=this.titleMessage
  [subTitleMessage]=this.subTitleMessage
  [detailMessage]=this.detailMessage
  [detailMessageLine1]=this.detailMessageLine1>
</lib-ctl-success-modal>

<!-- Error modal -->
<lib-modalform
    modalClass="errorModal"
    modalID="errorModal"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnCancelText]="'Ok'"
    (cancelEvent)="''">
    <div class="modalBody errorModalWidth">
        <div class="padLR20  padT20 flexStart">
            <div [ngClass]="textDir=='ltr'?'marR15':'marL15'">
                <img src="assets/images/error3x.png" width=29 height=29 alt="">
            </div>
            <div > 
            <label class="form-title" > {{this.titleMessage}}</label>           
            </div>
        </div>
        
        <div class="pad65 padR20 padB20 dialog-body-txt">
            <label  *ngIf="this.subTitleMessage"  [innerHTML]="subTitleMessage"></label>
            <label  *ngIf="this.detailMessage1"  [innerHTML]="detailMessage1"></label>
            <label  *ngIf="this.detailMessage2"  [innerHTML]="detailMessage2"></label>
        </div>
    </div>
</lib-modalform>
